import { render, staticRenderFns } from "./Ration.vue?vue&type=template&id=38f64094"
import script from "./Ration.vue?vue&type=script&lang=ts"
export * from "./Ration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports